import { Link } from "react-router-dom";
import { Reveal } from "@/components/site/Reveal";
import { Marquee } from "@/components/site/Marquee";

const CAM_IMG = "/gallery-pickup.webp";

const VALUES = [
  { t: "One booth, done right", c: "No franchise, no rotating staff. Just one carefully chosen vintage-style booth and one person who cares how your footage turns out." },
  { t: "Warm, never cheesy", c: "We keep it modern-nostalgic. No neon props, no 'OMG your big day' energy. Just a booth that quietly invites people to say something real." },
  { t: "Honest from the first email", c: "Flat pricing, clear policies, travel quoted upfront. You'll never wonder what a line item means." },
];

export default function About() {
  return (
    <div className="pt-32">
      <section className="px-5 sm:px-8 pb-16">
        <div className="max-w-[1400px] mx-auto grid lg:grid-cols-[1.2fr_0.8fr] gap-14 items-center">
          <div>
            <Reveal><p className="text-xs uppercase tracking-[0.3em] text-forest mb-6">About</p></Reveal>
            <Reveal delay={0.1}>
              <h1 className="font-serif text-5xl sm:text-7xl leading-[1.05]">
                A signature fades. <em className="text-forest">A voice doesn't.</em>
              </h1>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="text-ink/60 text-lg mt-8 max-w-xl leading-relaxed">
                The Event Club started with a simple frustration: guestbooks get shelved and never opened again. But hand someone a camera and one honest prompt, and they'll tell you something you'll never forget. So we built a booth for exactly that — a vintage-style video guestbook that turns a room full of people into a keepsake you'll actually rewatch.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <div className="clip-frame border border-clubborder bg-white p-3">
              <img src={CAM_IMG} alt="The vintage-style video booth" className="filmed clip-frame w-full h-[420px] object-cover" />
            </div>
          </Reveal>
        </div>
      </section>

      <Marquee text="A members' club for good stories" />

      <section className="px-5 sm:px-8 py-24">
        <div className="max-w-[1400px] mx-auto grid md:grid-cols-3 gap-10">
          {VALUES.map((v, i) => (
            <Reveal key={v.t} delay={i * 0.1}>
              <div className="border-t-2 border-forest pt-6">
                <span className="font-serif text-6xl text-forest/25">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="font-sans font-bold text-xl mt-3 mb-2">{v.t}</h3>
                <p className="text-ink/60 leading-relaxed">{v.c}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="px-5 sm:px-8 pb-24 text-center">
        <Reveal>
          <p className="font-serif italic text-4xl sm:text-5xl text-forest mb-8 max-w-3xl mx-auto">Serving weddings and celebrations across the Lower Mainland.</p>
          <Link to="/book" className="inline-block rounded-full bg-forest text-cream px-10 py-4 text-base hover:bg-forest-deep transition-colors">Check Your Date</Link>
        </Reveal>
      </section>
    </div>
  );
}
